import pt from '../../../locales/pt';

export function SmartGoalWhyStep({ why, onChange }) {
  const copy = pt.goals.wizard.why;

  return (
    <div className="flex flex-col gap-4 pt-3.5">
      <div className="text-center">
        <div className="text-[11px] font-bold uppercase tracking-[0.1em] text-sage-600 dark:text-sage-400">
          {copy.eyebrow}
        </div>
        <h1 className="mt-2 font-display text-2xl font-semibold leading-tight tracking-tight text-foreground">
          {copy.title}
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{copy.subtitle}</p>
      </div>

      <div className="relative rounded-[20px] bg-sage-50 px-[18px] py-5 dark:bg-sage-950/40">
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="absolute left-4 top-3.5 text-sage-200 dark:text-sage-800"
          aria-hidden
        >
          <path d="M9 7H6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h2v3H5v-2H4v4h6v-7H7V9h2zm10 0h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h2v3h-3v-2h-1v4h6v-7h-3V9h2z" />
        </svg>
        <textarea
          value={why}
          onChange={(e) => onChange(e.target.value)}
          rows={5}
          placeholder={copy.placeholder}
          className="w-full resize-none border-0 bg-transparent pt-5 font-display text-[17px] font-medium leading-relaxed text-foreground outline-none placeholder:text-muted-foreground/60 focus:ring-0"
        />
      </div>

      <p className="m-0 text-center text-xs text-muted-foreground">{copy.hint}</p>
    </div>
  );
}

export default SmartGoalWhyStep;
